/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Delete_CancelInputs */

const en_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_image_export_style_preset_delete_cancel = /** @type {(inputs: Image_Export_Style_Preset_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Image_Export_Style_Preset_Delete_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_delete_cancel = /** @type {((inputs?: Image_Export_Style_Preset_Delete_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Delete_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_delete_cancel(inputs)
	if (locale === "de") return de_image_export_style_preset_delete_cancel(inputs)
	if (locale === "it") return it_image_export_style_preset_delete_cancel(inputs)
	if (locale === "ru") return ru_image_export_style_preset_delete_cancel(inputs)
	if (locale === "es") return es_image_export_style_preset_delete_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_delete_cancel(inputs)
	if (locale === "ja") return ja_image_export_style_preset_delete_cancel(inputs)
	if (locale === "hi") return hi_image_export_style_preset_delete_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_delete_cancel(inputs)
	return en_image_export_style_preset_delete_cancel(inputs)
});